import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=95a2080e&scoped=true&"
import script from "./VideoForm.vue?vue&type=script&lang=js&"
export * from "./VideoForm.vue?vue&type=script&lang=js&"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=95a2080e&prod&lang=css&"
import style1 from "./VideoForm.vue?vue&type=style&index=1&id=95a2080e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a2080e",
  null
  
)

export default component.exports